import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const BenefitsContainer = styled.div`
  display: grid;
  max-width: 1260px;
  margin: 0em auto;
  width: 100%;  
  row-gap: 4rem;
  `

export const BenefitsTitle = styled.div`
  display: grid;
  row-gap: 4rem;
  
  @media all and (max-width: ${layout.md}) {
    row-gap: 2rem;
  }
`

export const Benefit = styled.div`
  display: grid;
  justify-self: center;
  column-gap: 3rem;
  grid-template-columns: 150px 300px;

  @media all and (max-width: ${layout.md}) {
    grid-template-columns: 1fr;
    width: 300px;
    row-gap: 1rem;
    
    div {
      justify-self: center;
    }
    p, h1 {
      justify-self: center;
      text-align: center;
    }
  }
`

export const BenefitText = styled.div`
  display: grid;
  row-gap: 0.5rem;
  align-self: center;

  @media all and (max-width: ${layout.md}) {
    row-gap: 1rem;
    justify-self: center;
  }
`
